import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import './styles.css';
import {IS_MOBILE} from '../../constants/environment';
import { DEFAULT_THRESHOLD_NORMAL } from '../../constants/layout';

export default class PhotogalleryItem extends Component {

  static scale = 1.05;

  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    imageSrc: PropTypes.string,
    deleteIconOnImage: PropTypes.bool,
    videoSrc: PropTypes.string,
    youtubeId: PropTypes.string,
    openModal: PropTypes.func,
    index: PropTypes.number,
    mbTwoColumn: PropTypes.bool,
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    imageSrc: null,
    deleteIconOnImage: null,
    videoSrc: null,
    youtubeId: null,
    openModal: null,
    index: null,
    mbTwoColumn: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      imageWidth: 0,
      imageHeight: 0,
      videoWidth: 0,
      videoHeight: 0,
      // imageWidth: '100%',
      // imageHeight: '100%',
      // videoWidth: '100%',
      // videoHeight: '100%',
      videoLoaded: false,
      opened: false,
    }
  }

  componentDidMount() {
    if (this.refs.video) {
      //
      setTimeout(() => {
        if (!this.state.videoLoaded) {
          this.refs.video.load();
        }
      }, 500);
      //
      this.refs.video.addEventListener('loadedmetadata', (e) => {
        window.addEventListener('resize', this.handleResizeVideo);
        this.handleResizeVideo();
      });
      this.refs.video.addEventListener('mouseenter', (e) => {
        this.refs.video.play();
      });
      this.refs.video.addEventListener('mouseleave', (e) => {
        this.refs.video.pause();
      });
    } else if (this.refs.image) {
      window.addEventListener('resize', this.handleResizeImage);
      this.handleResizeImage();
    }
    //
    if (this.props.imageSrc) {
      this.loadImage(this.props.imageSrc);
    }
  }

  componentWillUnmount() {
  }

  render() {
    const {
      containerId,
      containerClass,
      imageSrc,
      videoSrc,
      youtubeId,
      openModal,
      index,
      mbTwoColumn,
      trimSettingForMbTwoColumn,
    } = this.props;

    //
    const handleClick = (e) => {
      e.preventDefault();
      //
      if (openModal !== null) openModal(index);
    };

    //
    const getStyle = ()=> {
      let style = {
        position: 'absolute',
        backgroundImage: 'url(' + imageSrc + ')',
      };
      //
      const top = (this.state.imageHeight - (this.state.imageHeight * PhotogalleryItem.scale)) / 2;
      if (!isNaN(top)) {
        style.top = top;
      }
      //
      const left = (this.state.imageWidth - (this.state.imageWidth * PhotogalleryItem.scale)) / 2;
      if (!isNaN(left)) {
        style.left = left;
      }
      //
      const width = this.state.imageWidth * PhotogalleryItem.scale;
      if (0 < width) {
        style.width = width;
      }
      //
      const height = this.state.imageHeight * PhotogalleryItem.scale;
      if (0 < height) {
        style.height = height;
      }
      //
      return style;
    };

    const renderIcon = () => {
      if (this.props.deleteIconOnImage === true) return null;
      return (
        <span className="PhotogalleryItem__icon-open"/>
      )
    };

    const trimSettingClass = trimSettingForMbTwoColumn === 'Left' ?
      ' showLeft' : trimSettingForMbTwoColumn === 'Right' ?
      ' showRight' : '';

    //
    return (
      <Wrapper
        containerId={containerId}
        containerClass={containerClass}
      >
        <div className="PhotogalleryItem" ref="wrapper">
          {(() => {
            if (videoSrc && videoSrc !== '') {
              let autoPlay = false;
              if (IS_MOBILE) {
                autoPlay = true;
              }
              const attributes = {
                //preload: 'none',
                preload: 'metadata',
                controls: false,
                autoPlay: autoPlay,
                playsInline: true,
                muted: true,
                loop: true,
                src: videoSrc,
                //poster: imageSrc,
                width: this.state.videoWidth,
                height: this.state.videoHeight,
                // width: '100%',
                // height: '100%'
              };
              if (youtubeId && youtubeId !== '') {
                return (
                  <a className={'PhotogalleryItem__link' + (mbTwoColumn ? ' mbTwoColumn' : '')}
                     href="#"
                     onClick={handleClick}
                  >
                    <div className={'PhotogalleryItem__container' + ((this.state.videoLoaded === true) ? ' opened' : '')}>
                      <video
                        className={'PhotogalleryItem__video' + ((this.state.videoLoaded) ? ' loaded': '') + trimSettingClass} {...attributes}
                        ref="video"/>
                      <span className="PhotogalleryItem__icon-play"/>
                      {renderIcon()}
                    </div>
                  </a>
                )
              } else {
                return (
                  <a className={'PhotogalleryItem__link' + (mbTwoColumn ? ' mbTwoColumn' : '')}
                     href="#"
                     onClick={handleClick}
                  >
                    <div className={'PhotogalleryItem__container' + ((this.state.videoLoaded === true) ? ' opened' : '')}>
                      <video
                        className={'PhotogalleryItem__video' + ((this.state.videoLoaded) ? ' loaded': '') + trimSettingClass} {...attributes}
                        ref="video"/>
                      {renderIcon()}
                    </div>
                  </a>
                )
              }
            } else if (imageSrc && imageSrc !== '') {
              //
              if (youtubeId && youtubeId !== '') {
                return (
                  <a className={'PhotogalleryItem__link' + (mbTwoColumn ? ' mbTwoColumn' : '')}
                     href="#"
                     onClick={handleClick}
                  >
                    <div className={'PhotogalleryItem__container' + ((this.state.opened === true) ? ' opened' : '')}>
                      <div className={'PhotogalleryItem__image' + trimSettingClass}
                           style={getStyle()}
                           ref="image"
                      />
                      <span className="PhotogalleryItem__icon-play"/>
                      {renderIcon()}
                    </div>
                  </a>
                )
              } else {
                return (
                  <a className={'PhotogalleryItem__link' + (mbTwoColumn ? ' mbTwoColumn' : '')}
                     href="#"
                     onClick={handleClick}
                  >
                    <div className={'PhotogalleryItem__container' + ((this.state.opened === true) ? ' opened' : '')}>
                      <div className={'PhotogalleryItem__image' + trimSettingClass}
                             style={getStyle()}
                             ref="image"
                        />
                      {renderIcon()}
                    </div>
                  </a>
                )
              }
            } else {
              return null;
            }
          })()}
        </div>
      </Wrapper>
    );
  }

  handleResizeVideo = () => {
    if (!this.refs.wrapper) return;
    //
    const wrapperWidth = this.refs.wrapper.clientWidth;
    const wrapperHeight = this.refs.wrapper.clientHeight;
    const videoWidth = this.refs.video.videoWidth;
    const videoHeight = this.refs.video.videoHeight;
    let percent = null;
    let percentWidth = wrapperWidth / videoWidth;
    let percentHeight = wrapperHeight / videoHeight;
    if (percentWidth < percentHeight) {
      percent = percentHeight
    } else {
      percent = percentWidth
    }
    this.setState({
      videoWidth: videoWidth * percent,
      videoHeight: videoHeight * percent,
      // videoWidth: videoWidth * percent * 1.05,
      // videoHeight: videoHeight * percent * 1.05,
      videoLoaded: true,
    });
  };

  handleResizeImage = () => {
    if (!this.refs.wrapper) return;
    //
    const wrapperWidth = this.refs.wrapper.clientWidth;
    const wrapperHeight = this.refs.wrapper.clientHeight;
    const imageWidth = this.refs.image.clientWidth;
    const imageHeight = this.refs.image.clientHeight;
    let percent = null;
    let percentWidth = wrapperWidth / imageWidth;
    let percentHeight = wrapperHeight / imageHeight;
    if (percentWidth < percentHeight) {
      percent = percentHeight
    } else {
      percent = percentWidth
    }
    const newImageWidth = this.props.mbTwoColumn && window.innerWidth < DEFAULT_THRESHOLD_NORMAL ?
      wrapperWidth * 2 : imageWidth * percent;

    this.setState({
      imageWidth: newImageWidth,
      imageHeight: imageHeight * percent,
    });
  };

  loadImage = (src) => {
    const image = new Image();
    this.setState({
      opened: false,
    });
    image.onload = () => {
      this.setState({
        opened: true,
      });
    };
    image.src = src;
  }
}



// WEBPACK FOOTER //
// ./src/containers/photogallery-item/index.jsx